(function () {
  function getHeaderEl() {
    return (
      document.getElementById("HeaderWrapper") ||
      document.getElementById("SiteHeader")?.closest("#HeaderWrapper") ||
      document.querySelector(".header-wrapper") ||
      document.querySelector("#SiteHeader")
    );
  }

  function applyOffset() {
    const header = getHeaderEl();
    const ann = document.getElementById("shopify-section-announcement-bar");
    if (!header || !ann) return;

    const annStyle = window.getComputedStyle(ann);
    const annVisible = annStyle.display !== "none" && annStyle.visibility !== "hidden";

    if (!annVisible) {
      header.style.top = "";
      header.style.marginTop = "";
      return;
    }

    const annRect = ann.getBoundingClientRect();
    const headerRect = header.getBoundingClientRect();

    // Alleen corrigeren als er daadwerkelijk overlap is
    const overlaps = headerRect.top < (annRect.bottom - 1);
    const h = Math.round(annRect.height);

    if (!overlaps || h <= 0) {
      header.style.top = "";
      header.style.marginTop = "";
      return;
    }

    const pos = window.getComputedStyle(header).position;

    // Fixed/sticky/absolute => top corrigeren
    if (pos === "fixed" || pos === "sticky" || pos === "absolute") {
      header.style.top = h + "px";
      header.style.marginTop = "";
    } else {
      // Normale flow => margin-top
      header.style.marginTop = h + "px";
      header.style.top = "";
    }
  }

  // Run
  window.addEventListener("load", applyOffset);
  window.addEventListener("resize", function () {
    window.requestAnimationFrame(applyOffset);
  });

  // Shopify editor events
  document.addEventListener("shopify:section:load", applyOffset);
  document.addEventListener("shopify:section:unload", applyOffset);

  // Kleine extra tick voor fonts/layout shifts
  setTimeout(applyOffset, 200);
})();
